 <div class="informacoes-cartao informacoes-proposta" style="border-style: groove;">
      <h2>Proposta de acordo</h2>
      <div *ngIf="ofertaAtual?.plano > 1; else unica">
      <div class="info-container">
            <div class="info-column">
              <p>Forma de pagamento: <strong>Parcelado</strong></p>
              <p>Data de vencimento: <strong>{{debt?.dataNegociacao| date: 'dd/MM/yyyy'}}</strong></p>
              <p>Valor da entrada: <strong>{{ofertaAtual?.valorEntrada| currencyMask}}</strong></p>
            </div>

            <div class="info-column">
              <p>Parcelas: <strong>{{ofertaAtual?.plano -1}}x {{ofertaAtual?.valorParcela| currency:'BRL'}}</strong></p>
              <p>Valor total do acordo: <strong>{{ofertaAtual?.valorAcordo| currency:'BRL'}}</strong></p>
              <!-- <p>Status do acordo: <span class="status-acordo disponivel">Disponível</span></p> -->
            </div>
        </div>
    </div>
        <ng-template #unica>
            <div class="info-container">
                <div class="info-column">
                  <p>Forma de pagamento: <strong>À vista</strong></p>
                  <p>Previsão de vencimento: <strong>{{debt?.dataNegociacao| date: 'dd/MM/yyyy'}}</strong></p>
                  <p>Valor da parcela: <strong>{{ofertaAtual?.valorEntrada| currencyMask}}</strong></p>
                </div>
            </div>
            
        </ng-template>
    </div>
